import { useMutation } from '@tanstack/react-query';

import type { EvidenceSBSConfirmResponse } from '@heidi/evidence/contracts';
import { logger } from '@heidi/runtime/logger';
import { postEvidenceSBSConfirm, type EvidenceSBSConfirmRequest } from '../api';

export const CONFIRM_EVIDENCE_SBS_KEY = 'CONFIRM_EVIDENCE_SBS';

export function useConfirmEvidenceSBSMutation() {
  return useMutation<
    EvidenceSBSConfirmResponse,
    Error,
    { reqBody: EvidenceSBSConfirmRequest }
  >({
    mutationKey: [CONFIRM_EVIDENCE_SBS_KEY],
    mutationFn: async ({ reqBody }) => {
      const response = await postEvidenceSBSConfirm(reqBody);
      if (!response.data.success) {
        throw new Error('Evidence SBS confirm returned success: false');
      }
      return response.data;
    },
    onError(err) {
      logger.error('[EVIDENCE_SBS] confirm failed', err);
    },
  });
}
